'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { H2 } from '@/frontend/design-system/_marketing/typography/Heading';
import { P2 } from '@/frontend/design-system/_marketing/typography/Paragraph';
import { Button } from '@/frontend/design-system/actions/Button';
import { IllustrationOnTheLeftLayout } from '@/frontend/design-system/layouts/IllustrationOnTheLeftLayout';
import { VerticalSpacer } from '@/frontend/design-system/layouts/VerticalSpacer';
import { EbookPopup } from '../_components/EbookPopup';
import ManReadingAnArticle from '../_svg/ManReadingAnArticle';
export function EbookSection() {
  const $ = _c(9);
  const [isEbookOpen, setEbookOpen] = useState(false);
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ManReadingAnArticle />;
    t1 = <H2>Darmowy e-book</H2>;
    t2 = <VerticalSpacer size="content" />;
    t3 = <P2>Przedstawiliśmy Ci tylko ogólny zarys tego, w jaki sposób nauczamy w AlgoAcademy. Jeśli zaciekawiliśmy Cię naszą metodą nauczania, zachęcamy do przeczytania naszego e-booka, gdzie przedstawiamy ją w sposób bardziej szczegółowy.</P2>;
    t4 = <VerticalSpacer size="content" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IllustrationOnTheLeftLayout illustration={t0}>{t1}{t2}{t3}{t4}<Button size="xl" onClick={() => setEbookOpen(true)} className="w-full lg:w-fit">Pobierz e-book</Button></IllustrationOnTheLeftLayout>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setEbookOpen(false);
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== isEbookOpen) {
    t7 = <>{t5}<EbookPopup open={isEbookOpen} onClose={t6} /></>;
    $[7] = isEbookOpen;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
}